<sui-dialog-simple [(error)]="apiError">
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ "offboard-user.title.disable-account" | translate }}
    </h2>

    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="plan-execute">
      <sui-detail-list class="offboard-user__facts">
        <sui-detail-item [label]="'offboard-user.label.user' | translate"
          ><span class="offboard-user__name">{{ user.display_name }}</span>
          <span class="offboard-user__email">{{
            user.email
          }}</span></sui-detail-item
        >
        <sui-detail-item [label]="'offboard-user.label.company' | translate">{{
          user.company_name
        }}</sui-detail-item>
      </sui-detail-list>

      <section class="plan-execute__section">
        <h3 class="plan-execute__heading">
          {{ "offboard-user.section.new-owner" | translate }}
        </h3>
        <p class="plan-execute__lead">
          {{
            "offboard-user.text.the-objects-the-user-owns-pass-to-this-colleague"
              | translate
          }}
        </p>
        <div class="offboard-user__owner">
          @if (newOwner(); as owner) {
            <span class="offboard-user__owner-name">
              {{ owner.name }}
              @if (owner.email) {
                <span class="offboard-user__email">{{ owner.email }}</span>
              }
            </span>
          } @else {
            <span class="plan-execute__lead">
              {{ "offboard-user.text.no-owner-chosen" | translate }}
            </span>
          }
          <sui-button
            size="sm"
            variant="secondary"
            [leadingIcon]="['fas', 'user']"
            [disabled]="!!outcome()"
            (click)="chooseNewOwner()"
          >
            {{ "offboard-user.button.choose" | translate }}
          </sui-button>
        </div>
        <sui-switch
          [ngModel]="sharedOnly()"
          [disabled]="!!outcome()"
          (ngModelChange)="setSharedOnly($event)"
          >{{
            "offboard-user.switch.shared-objects-only" | translate
          }}</sui-switch
        >
      </section>

      @if (report(); as report) {
        <section class="plan-execute__section">
          <h3 class="plan-execute__heading">
            {{ "offboard-user.section.objects-to-hand-over" | translate }}
          </h3>
          @if (handoverRows().length > 0) {
            <div class="review-table-wrap review-table-wrap--compact">
              <table class="review-table">
                <thead>
                  <tr>
                    <th>
                      {{ "offboard-user.column.object-class" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "offboard-user.column.active" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "offboard-user.column.archived" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "offboard-user.column.deleted" | translate }}
                    </th>
                    <th class="review-table__num">
                      {{ "offboard-user.column.shared" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of handoverRows(); track row.key) {
                    <tr>
                      <td class="review-table__name">
                        {{
                          "move-user-company.class." + row.labelKey | translate
                        }}
                      </td>
                      <td class="review-table__num">{{ row.active }}</td>
                      <td class="review-table__num">{{ row.archived }}</td>
                      <td class="review-table__num">{{ row.deleted }}</td>
                      <td class="review-table__num">{{ row.shared }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="plan-execute__lead">
              {{ "offboard-user.text.no-objects-to-hand-over" | translate }}
            </p>
          }
        </section>

        <section class="plan-execute__section">
          <h3 class="plan-execute__heading">
            {{ "offboard-user.section.what-happens" | translate }}
          </h3>
          <ul class="plan-execute__list">
            <li>
              {{
                "offboard-user.warning.sessions-signed-out"
                  | translate: { count: report.sessions }
              }}
            </li>
            <li>
              {{ "offboard-user.warning.account-disabled" | translate }}
            </li>
          </ul>
        </section>
      }

      @if (outcome(); as outcome) {
        <section
          class="plan-execute__results"
          [class.plan-execute__results--failed]="!executed()"
        >
          <h3 class="plan-execute__heading">
            {{
              (executed()
                ? "offboard-user.result.account-disabled"
                : "offboard-user.result.offboarding-failed"
              ) | translate
            }}
          </h3>
          @if (outcome.report.results; as results) {
            <p>
              {{
                "offboard-user.result.applied-skipped-failed"
                  | translate
                    : {
                        applied: results.applied,
                        skipped: results.skipped,
                        failed: results.failed,
                      }
              }}
            </p>
            @if (results.failures.length > 0) {
              <ul class="plan-execute__list">
                @for (failure of results.failures; track failure.action_id) {
                  <li>
                    <span class="plan-execute__failure-object">{{
                      failure.object_id
                    }}</span>
                    {{ failure.reason }}
                  </li>
                }
              </ul>
            }
          }
        </section>
      }
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    @if (!outcome()) {
      <sui-button size="sm" variant="secondary" (click)="cancel()">
        {{ "btn.cancel" | translate }}
      </sui-button>
      @if (!report()) {
        <sui-button
          size="sm"
          variant="primary"
          [disabled]="!canPlan()"
          [loading]="planMutation.isPending()"
          (click)="plan()"
        >
          {{ "offboard-user.button.plan" | translate }}
        </sui-button>
      } @else {
        <sui-button
          size="sm"
          variant="danger"
          [leadingIcon]="['fas', 'user-slash']"
          [disabled]="!canConfirm()"
          [loading]="executeMutation.isPending()"
          (click)="confirm()"
        >
          {{ "offboard-user.button.disable-account" | translate }}
        </sui-button>
      }
    } @else {
      <sui-button size="sm" variant="primary" (click)="finish()">
        {{ "btn.close" | translate }}
      </sui-button>
    }
  </ng-template>
</sui-dialog-simple>
